var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useEffect, useRef, useState } from 'react';
import { raiseDecimalPoint } from '../../utils/math';
/**
 * # Image
 *
 * 이미지 컴포넌트.
 *
 * 1. 이미지를 불러오기 전 로딩을 진행하고
 * 2. 로딩이 완료되면 fade-in 애니메이션으로 보여줍니다.
 *
 * @param {ImageProps} {@link ImageProps} 기본적인 프롭
 *
 * @example ```tsx
  <Image
    src={`https://assets.vercel.com/image/upload/q_auto/front/zeit/og.png`}
    width={540}
    height={300}
    margin={0}
  />

  <Image
    src={`https://assets.vercel.com/image/upload/q_auto/front/assets/design/components/triangle.gif`}
    width={540}
    height={309}
    margin={0}
    caption='Source: giphy.com'
    captionSpacing={20}
  />
 * ```
 */
export var ImageComponent = function (props) {
    var caption = props.caption, captionSpacing = props.captionSpacing, src = props.src, otherProps = __rest(props, ["caption", "captionSpacing", "src"]);
    var ref = useRef(null);
    var _a = useState(null), imgSrc = _a[0], setImgSrc = _a[1];
    useEffect(function () {
        var imageLoader = new Image();
        imageLoader.src = src;
        imageLoader.onload = function () {
            setImgSrc(src);
        };
        return function () {
            imageLoader.onload = null;
        };
    }, []);
    var height = raiseDecimalPoint((otherProps.height / otherProps.width) * 100);
    var onlyProps = {
        src: imgSrc
    };
    return (<Container {...onlyProps} {...otherProps} show={!!imgSrc}>
      <Main width={otherProps.width}>
        <Wrapper height={height}>
          <Img ref={ref} decoding='async' src={imgSrc !== null && imgSrc !== void 0 ? imgSrc : ''}/>
        </Wrapper>
        {caption && <Caption style={{ marginTop: "".concat(captionSpacing, "px") }}>{caption}</Caption>}
      </Main>
    </Container>);
};
var Container = styled.figure(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  text-align: center;\n\n  ", "\n"], ["\n  display: block;\n  text-align: center;\n\n  ", "\n"])), function (_a) {
    var show = _a.show, margin = _a.margin;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: ", "px 0;\n    opacity: ", ";\n    transition: opacity 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955);\n  "], ["\n    margin: ", "px 0;\n    opacity: ", ";\n    transition: opacity 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955);\n  "])), margin !== null && margin !== void 0 ? margin : 0, show ? 1 : 0);
});
var Main = styled.main(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var width = _a.width;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: ", "px;\n    margin: 0 auto;\n    max-width: 100%;\n  "], ["\n    width: ", "px;\n    margin: 0 auto;\n    max-width: 100%;\n  "])), width);
});
var Wrapper = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  position: relative;\n  ", "\n"], ["\n  display: flex;\n  justify-content: center;\n  position: relative;\n  ", "\n"])), function (_a) {
    var height = _a.height;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding-bottom: ", "%;\n  "], ["\n    padding-bottom: ", "%;\n  "])), height);
});
var Img = styled.img(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n"], ["\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n"])));
var Caption = styled.p(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    color: ", ";\n    font-size: 0.875rem;\n    text-align: center;\n  "], ["\n    color: ", ";\n    font-size: 0.875rem;\n    text-align: center;\n  "])), theme.colors.PRIMARY.ACCENT_5);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=index.jsx.map